var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"chips":"","items":_vm.itemsValue,"label":'Pick your classification (required)',"hint":"Pick your classification","item-text":"name","item-value":"id","menu-props":"auto","persistent-hint":""},model:{value:(_vm.classificationId),callback:function ($$v) {_vm.classificationId=$$v},expression:"classificationId"}})
}
var staticRenderFns = []

export { render, staticRenderFns }